import { fastTransformer } from '../form';
import { required } from '../validation';

/**
 * Company360 è una tabella polimorfica: un record può essere collegato ad UNO SOLO tra
 * Company / Service / FoodService / Retailer / Brand, e ne deve avere ESATTAMENTE uno.
 *
 * Questo transformer impone il vincolo lato interfaccia:
 *  - all'inizio tutti e cinque i riferimenti sono obbligatori, così da forzare una scelta;
 *  - appena ne viene selezionato uno, gli altri quattro vengono disabilitati e resi non
 *    obbligatori, garantendo che ne resti valorizzato esattamente uno.
 */

const POLYMORPHIC_FIELDS = [
	'Company',
	'Service',
	'FoodService',
	'Retailer',
	'Brand',
];

const setRequired = (f: any, isRequired: boolean) => {
	f.required = isRequired;
	f.validators = (f.validators || []).filter((v: any) => v !== required);
	if (isRequired) {
		f.validators.push(required);
		if (f.label.indexOf('*') === -1) {
			f.label = f.label + '*';
		}
	} else {
		f.label = f.label.replace('*', '');
	}
};

const makeAfterChange = (fieldName: string) => (
	_ff: any,
	value: any,
	fields: any[],
) => {
	// un riferimento è "attivo" se il campo appena modificato ha un valore: in quel caso
	// disabilito gli altri quattro e li rendo non obbligatori; quando viene svuotato torno
	// allo stato iniziale (tutti obbligatori) così da forzare comunque una scelta.
	const selected = value !== null && value !== undefined;
	const others = POLYMORPHIC_FIELDS.filter((name) => name !== fieldName);
	fields
		.filter((f) => others.indexOf(f.name) > -1)
		.forEach((f) => {
			f.disabled = selected;
			setRequired(f, !selected);
			f.changed = true;
		});
	return fields;
};

export const company360Transformer = (
	data: any,
	_entity?: any,
	_listsByType?: any,
) => {
	const assocs = POLYMORPHIC_FIELDS.reduce(
		(acc, fieldName) => {
			acc[fieldName] = (f: any) => {
				// stato iniziale: tutti obbligatori (nessuna selezione ancora fatta)
				setRequired(f, true);
				f.afterChange = makeAfterChange(fieldName);
				return f;
			};
			return acc;
		},
		{} as { [key: string]: (f: any) => any },
	);

	data.fields = fastTransformer(assocs)(data.fields);
	return data;
};